module.exports = __webpack_public_path__ + "static/img/heroimage_seclesson_large.314fc89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_seclesson_large.png
// module id = 77
// module chunks = 1